import { normalizeNewlines } from '@/lib/string-utils.js';

export function ReviewHistoryMetadata({
  studentAttended,
  studentIssueLabels,
  classNotes,
  description,
}: {
  studentAttended: boolean | null;
  studentIssueLabels: string[];
  classNotes: string | null;
  description: string | null;
}) {
  const showAbsent = studentAttended === false;
  const studentIssueText = studentIssueLabels.join(', ');
  const notes = classNotes ? normalizeNewlines(classNotes).trim() || null : null;
  const hasMetadata = Boolean(showAbsent || studentIssueText || notes);
  const summary = description ? normalizeNewlines(description) : hasMetadata ? null : '-';

  return (
    <>
      {hasMetadata ? (
        <ul className="mt-4 list-disc pl-5">
          {showAbsent ? <li className="break-words [overflow-wrap:anywhere]">Student Absent</li> : null}
          {studentIssueText ? (
            <li className="break-words [overflow-wrap:anywhere]">Student Issues: {studentIssueText}</li>
          ) : null}
          {notes ? (
            <li className="whitespace-pre-line break-words [overflow-wrap:anywhere]">Class Notes: {notes}</li>
          ) : null}
        </ul>
      ) : null}
      {summary ? <div className="mt-4 whitespace-pre-line break-words [overflow-wrap:anywhere]">{summary}</div> : null}
    </>
  );
}
